import React, { memo, useRef } from 'react'
import { useSelector } from 'react-redux'
import ServiceCard from 'Components/ServiceCard/ServiceCard'
import './DescriptionCell.css'

/**
 * Componente para mostrar la descripción de un producto y sus servicios relacionados
 */
const DescriptionCell = memo(({ description, productId }) => {
  const containerRef = useRef(null)
  const cart = useSelector(state => state.cart.cart)

  const product = cart.find(item => item.ProductId === productId)
  const installable = product?.installable
  const relatedServices = product?.relatedServices || []

  const shouldRenderServiceCard = Boolean(
    installable &&
      Array.isArray(relatedServices) &&
      relatedServices.length > 0 &&
      relatedServices[0]?.productId
  )

  const containerClassName = [
    'product-description-container',
    shouldRenderServiceCard ? 'with-service' : '',
  ]
    .filter(Boolean)
    .join(' ')

  const serviceContainerClassName = [
    'service-container',
    shouldRenderServiceCard ? 'visible' : 'hidden',
  ].join(' ')

  return (
    <div className={containerClassName} ref={containerRef}>
      <div className="product-description">{description}</div>

      <div className={serviceContainerClassName}>
        {shouldRenderServiceCard && (
          <div id={`service-card-container-${productId}`}>
            <ServiceCard
              services={relatedServices}
              titleStyle={{ fontSize: '12px' }}
            />
          </div>
        )}
      </div>
    </div>
  )
})

DescriptionCell.displayName = 'DescriptionCell'

export default DescriptionCell
